/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {FC, useEffect} from 'react'
import {useIntl} from 'react-intl'
import {PageLink, PageTitle} from '../../../../_metronic/layout/core'

import DashboardPage from './DashBoardPage'
import {ContactClosePopup, ContactStartUpload} from '../../../Components/PopupSlice/popupSlice'
import {
  systemNotification,
  portalNotification,
} from '../../../Redux/NotificationSlice/NotificationSlice'
import {useSocket} from '../../../Utils/SocketProvider'
import {useDispatch, useSelector} from 'react-redux'
import {
  selectedProfile,
  setSelectedDashboard,
} from '../../../Redux/FrontEnd/ProDashboardSlices/ProDashboardSlice'
import {getAllUserDetails} from '../accounts/Overview/OverviewSlice/UserDetailsSlice'

const DashboardWrapper: FC = () => {
  const sys = useSelector((state: any) => state?.notification?.system)
  const port = useSelector((state: any) => state?.notification?.portal)
  const socketID: any = useSocket()
  const dispatch = useDispatch()

  // useEffect(() => {
  //   socketID.on('connect', () => {
  //     console.log(`socket is connected`)
  //     socketID.on('notification', (data: any) => {
  //       console.log(data)
  //     })
  //   })
  // }, [])
  // socketID?.on('notification', (data: any) => {
  //   console.log(data, 'KKKKKKKKKKKKKKKKK')

  //   if (
  //     data?.type == 'system' &&
  //     sys?.find((key: any) => key?._id == data?._id)?._id == undefined
  //   ) {
  //     dispatch(systemNotification([...sys, data]))
  //   }
  //   if (
  //     data?.type == 'inbox' &&
  //     port?.find((key: any) => key?._id == data?._id)?._id == undefined
  //   ) {
  //     dispatch(portalNotification([...port, data]))
  //   }
  //   if (data?.type == 'contact_upload') {
  //     dispatch(ContactClosePopup())
  //     dispatch(ContactStartUpload())
  //     dispatch(portalNotification([...port, data]))
  //   }
  // })
  // useEffect(() => {
  //   socketID?.on('notification', (data: any) => {
  //     console.log(data, 'KKKKKKKKKKKKKKKKK')

  //     if (
  //       data?.type == 'system' &&
  //       sys?.find((key: any) => key?._id == data?._id)?._id == undefined
  //     ) {
  //       dispatch(systemNotification([...sys, data]))
  //     }
  //     if (
  //       data?.type == 'inbox' &&
  //       port?.find((key: any) => key?._id == data?._id)?._id == undefined
  //     ) {
  //       dispatch(portalNotification([...port, data]))
  //     }
  //     if (data?.type == 'contact_upload') {
  //       dispatch(ContactClosePopup())
  //       dispatch(ContactStartUpload())
  //       dispatch(portalNotification([...port, data]))
  //     }
  //   })
  // }, [])

  return <DashboardPage />
}

export {DashboardWrapper}
